import axios, { AxiosError } from 'axios';
import store from 'store';

import { useQuery } from '@tanstack/react-query';

const getCampaignOwnersList: {
  (): Promise<any>;
} = async () => {
  const header = {
    Authorization: `Token ${store.getState().user.token}`,
  };

  const res = await axios({
    baseURL: process.env.REACT_APP_ADSERVER_ENDPOINT + '/campaigns/owners',
    method: 'GET',
    headers: header,
  });
  return res;
};

export const useGetCampaignOwnersList = (): {
  campaignOwnersListData: any;
  campaignOwnersListStatus: string;
  isCampaignOwnersListLoading: boolean;
} => {
  const { data, status, isLoading } = useQuery<any, AxiosError>({
    queryKey: ['campaignOwnersList'],
    queryFn: () => getCampaignOwnersList(),
    refetchOnWindowFocus: false,
    keepPreviousData: true,
  });
  return {
    campaignOwnersListData: data,
    campaignOwnersListStatus: status,
    isCampaignOwnersListLoading: isLoading,
  };
};

const getCurrentCampaignOwnersList: {
  (id: number): Promise<any>;
} = async id => {
  const header = {
    Authorization: `Token ${store.getState().user.token}`,
  };

  const res = await axios({
    baseURL: process.env.REACT_APP_ADSERVER_ENDPOINT + `/campaign/${id}/users`,
    method: 'GET',
    headers: header,
  });
  return res;
};

export const useGetCurrentCampaignOwnersList = (
  id: number,
  options?: { enabled?: boolean },
): {
  data: any;
  status: string;
  isLoading: boolean;
} => {
  const { data, status, isLoading } = useQuery<any, AxiosError>({
    queryKey: ['currentCampaignOwnersList', id],
    queryFn: () => getCurrentCampaignOwnersList(id),
    refetchOnWindowFocus: false,
    keepPreviousData: true,
    ...options,
  });

  return {
    data,
    status,
    isLoading,
  };
};
